// Pages that render inside a partner's iframe (`/embed/[tenantSlug]`).
//
// Deliberately import-free: the root layout checks this on every route, so it
// must not pull any embed code into the shell every page loads.

/** Embedded pages get no consent banner and no page-view analytics. */
export function isEmbedPath(pathname: string): boolean {
  return pathname === "/embed" || pathname.startsWith("/embed/");
}
